import { load as loadMultiTenantOrganizationDetails } from '@ms/yammer-data/dist/domains/multiTenantOrganizationDetails/actions';
import { Experiment } from '@ms/yammer-data/dist/state/ecsExperiments/types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useAndReportExperimentTreatment } from '../experiments';

type UseLoadMultiTenantOrganizationDetails = () => void;
export const useLoadMultiTenantOrganizationDetails: UseLoadMultiTenantOrganizationDetails = () => {
  const isMultiTenantOrganizationEnabled = useAndReportExperimentTreatment(Experiment.MultiTenantOrganization);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!isMultiTenantOrganizationEnabled) {
      return;
    }
    dispatch(loadMultiTenantOrganizationDetails());
  }, [dispatch, isMultiTenantOrganizationEnabled]);
};
